import { render, staticRenderFns } from "./GroupForm.vue?vue&type=template&id=f77ed9ca"
import script from "./GroupForm.vue?vue&type=script&lang=js"
export * from "./GroupForm.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/basic/form.less?vue&type=style&index=0&prod&lang=less&external"
import style1 from "./GroupForm.vue?vue&type=style&index=1&id=f77ed9ca&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports